import { Address } from 'viem'
import { CurrencyType } from './get-acceptable-currencies'
import { CurrencyMetadata } from 'indices-list'

export class UnRegisteredProductError extends Error {
  constructor(address: string) {
    super(`Unable to find atom for product with address ${address}, have the atoms been added?`)
    this.name = 'UnRegisteredProductError'
    Object.setPrototypeOf(this, UnRegisteredProductError.prototype)
  }
}

export class UnsupportedNetworkError extends Error {
  // TODO: expected and current chainId-s
  constructor(chainId: number) {
    super(`Unsupported network chainId: ${chainId}`)
    this.name = 'UnsupportedNetworkError'
    Object.setPrototypeOf(this, UnsupportedNetworkError.prototype)
  }
}

export class EmptyArrayError extends Error {
  constructor() {
    super('Array is empty')
    this.name = 'EmptyArrayError'
    Object.setPrototypeOf(this, EmptyArrayError.prototype)
  }
}

export class RequestError extends Error {
  constructor() {
    super('Invalid response')
    this.name = 'RequestError'
    Object.setPrototypeOf(this, RequestError.prototype)
  }
}

export class RPCCallFailedError extends Error {
  constructor(address: Address) {
    super(`Failed to call the function for ${address} address`)
    this.name = 'RPCCallFailedError'
    Object.setPrototypeOf(this, RPCCallFailedError.prototype)
  }
}

export class RPCResponseMultiCallError extends Error {
  constructor(errors: string[]) {
    super(
      `RPC multi call responded with an error for ${errors.length} calls: \n ${errors.join('\n')}`,
    )
    this.name = 'RPCResponseMultiCallError'
    Object.setPrototypeOf(this, RPCResponseMultiCallError.prototype)
  }
}

export class InvalidActionError extends Error {
  constructor(action: unknown) {
    super(`Action is invalid ${action}`)
    this.name = 'InvalidActionError'
    Object.setPrototypeOf(this, InvalidActionError.prototype)
  }
}

export class InvalidStateError extends Error {
  constructor(state: unknown) {
    super(`Invalid state ${state}`)
    this.name = 'InvalidStateError'
    Object.setPrototypeOf(this, InvalidStateError.prototype)
  }
}

export class UnsupportedCurrencyError extends Error {
  constructor(currencyType: CurrencyType) {
    super(`Invalid currency ${currencyType}`)
    this.name = 'UnsupportedCurrencyError'
    Object.setPrototypeOf(this, UnsupportedCurrencyError.prototype)
  }
}

export class UndefinedCoingeckoId extends Error {
  constructor(currency: CurrencyMetadata) {
    super(`Currency with undefined coingecko id: ${currency}`)
    this.name = 'UndefinedCoingeckoId'
    Object.setPrototypeOf(this, UndefinedCoingeckoId.prototype)
  }
}

export class UnknownProductTypeError extends Error {
  constructor(type: unknown) {
    super(`Unknown product  ${type}`)
    this.name = 'UnknownProductTypeError'
    Object.setPrototypeOf(this, UnknownProductTypeError.prototype)
  }
}

export class EmptyProviderError extends Error {
  constructor() {
    super('Failed to get the provider')
    this.name = 'EmptyProviderError'
    Object.setPrototypeOf(this, EmptyProviderError.prototype)
  }
}
export class UnsupportedProductTypeError extends Error {
  constructor(type: unknown) {
    super(`${type} is not supported`)
    this.name = 'UnsupportedProductTypeError'
    Object.setPrototypeOf(this, UnsupportedProductTypeError.prototype)
  }
}
